import jQuery from 'jquery';

(function ($) {
  'use strict';

  const placeholderClass = 'tx-intdiv-responsive-image-placeholder';

  const swapSources = (image) => {
    ['srcset', 'src'].forEach((attributeName) => {
      const dataAttributeName = 'data-attr-' + attributeName;
      const attributeValue = image.attr(dataAttributeName);
      if (!attributeValue) {
        return;
      }

      image.attr(attributeName, attributeValue);
      image.removeAttr(dataAttributeName);
    });

    image.removeClass(placeholderClass);
  };

  // Unrendered images (width 0) keep the placeholder until they get a box: Chrome stops deferring
  // a lazy image once its placeholder came from the memory cache, real sources would load.
  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const width = Math.ceil(entry.contentRect.width);
      if (width === 0) {
        return;
      }

      const image = $(entry.target);
      image.attr('sizes', width + 'px');
      if (image.hasClass(placeholderClass)) {
        swapSources(image);
      }
    });
  });

  const observe = (images) => {
    images.each(function () {
      observer.observe(this);
    });
  };

  observe($('.' + placeholderClass));

  $(window).on('responsive.image.reload', () => {
    observe($('.' + placeholderClass));
  });
})(jQuery);
